import module from 'viaticos/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('viaticos.pendientes.timbrar', {
    url: '/timbrar',
    data: {title: 'Pagar'},
    resolve: {
      busqueda: ($stateParams) => {
        $stateParams.busqueda = {}
        $stateParams.busqueda.fechaInicial = $stateParams.fechaInicial
        $stateParams.busqueda.fechaFinal = $stateParams.fechaFinal
        return $stateParams.busqueda
      },
    },
    template: '<viaticos-timbrar busqueda="busqueda"></viaticos-timbrar>',
    controller: ($scope, busqueda) => {
      $scope.busqueda = busqueda
    },
  })
})



// WEBPACK FOOTER //
// ./src/viaticos/routes/viaticos/pendientes/timbrar.js